module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Medium.9a31bf38.woff2";